function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M63.023 90.382c14.185 0 25.684-11.499 25.684-25.683 0-14.185-11.5-25.684-25.684-25.684-14.185 0-25.684 11.5-25.684 25.684 0 14.184 11.5 25.683 25.684 25.683z",
  stroke: "#073331",
  strokeWidth: 5.188,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.047 112.843l6.936 6.936a4.207 4.207 0 006.197-.265l25.128-29.74a4.228 4.228 0 00-.238-5.707l-2.338-2.338a4.227 4.227 0 00-5.707-.238L8.31 106.646a4.209 4.209 0 00-.264 6.197z",
  stroke: "#073331",
  strokeWidth: 5.188,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M63.023 90.382c14.185 0 25.684-11.499 25.684-25.683 0-14.185-11.5-25.684-25.684-25.684-14.185 0-25.684 11.5-25.684 25.684 0 14.184 11.5 25.683 25.684 25.683z",
  stroke: "#073331",
  strokeWidth: 5.188,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M64.701 15.578V3",
  stroke: "#FFD747",
  strokeWidth: 5.188,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M64.7 126.411v-12.578M99.447 29.965l8.892-8.891",
  stroke: "#A4E7DB",
  strokeWidth: 5.188,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M113.833 64.699h12.578M3 64.699h12.578",
  stroke: "#f59bbb",
  strokeWidth: 5.188,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M99.447 99.445l8.892 8.892",
  stroke: "#FFD747",
  strokeWidth: 5.188,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.075 21.074l8.891 8.891",
  stroke: "#A4E7DB",
  strokeWidth: 5.188,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgSearch;